import { stringify } from "qs";
import request from "../request";
import { url } from "../service-utils";
import { GetQueryString } from "../utils";

// 精选列表接口
export async function selectedList(params) {
  return request(
    `${url.activitySign}/activity/recommend-record/page-list?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 精选图片导出url
export function getPhotoArrayUrl(params) {
  return request(
    `${url.activitySign}/activity/recommend-record/download-pic?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 精选表格导出url
export function getListArrayUrl(params) {
  return request(
    `${url.activitySign}/activity/recommend-record/download-excel?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}
